export const WEBSITE_VERSION = '0.0.1';
